<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @editCustomsBillNo="openCustomsBillNo"
        :checked-count="checkedCount"
      />
    </page-main>
    <EditCustomsBillNo
      :visible.sync="customsBillNoDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_shipment_packingOrder_edit') ||
          '批量编辑海关编号'
      "
      :listOrderCode="customsBillNoDialogOptions.listOrderCode"
      @reload="editReload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditCustomsBillNo from '../edit-customsBillNo/dialog.vue'
export default {
  mixins: [BaseTable],
  components: { PageHeader, PageMain, EditCustomsBillNo },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      checkedRow: [],
      customsBillNoDialogOptions: { visible: false, listOrderCode: [] },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      this.loading = true
      this.$api
        .shipmentPackingOrderListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openCustomsBillNo() {
      if (!this.checkedCount) return
      const listOrderCode = this.checkedRow.map(
        (item) => item.shipmentPackingOrderCode
      )
      this.customsBillNoDialogOptions = { visible: true, listOrderCode }
    },
    editReload() {
      this.checkedRow = []
      this.reload()
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
